export function domContentLoaded(f: () => void) {
  if (document.readyState === 'loading') {  // Loading hasn't finished yet
    document.addEventListener('DOMContentLoaded', f);
  } else {  // `DOMContentLoaded` has already fired
    f()
  }
}
